import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Home, ChevronLeft, ChevronRight, ArrowRight, TrendingUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const Properties = () => {
  const navigate = useNavigate();

  // États pour les carrousels
  const [currentImageGemini, setCurrentImageGemini] = useState(0);
  const [currentImageCombins, setCurrentImageCombins] = useState(0);
  const [currentImageTufetsch, setCurrentImageTufetsch] = useState(0);
  const [currentImageLabadine, setCurrentImageLabadine] = useState(0);

  // Chalet Gemini 1308
  const chaletGemini = {
    id: 'gemini',
    title: "Chalet Gemini 1308",
    location: "Verbier, Médières",
    description: "Chalets mitoyens haut de gamme de 270m² à Médières, Val de Bagnes, à 5 minutes de Verbier. 3 chambres, spa privatif, label Minergie. Un lieu d'exception dans les Alpes Suisses.",
    images: [
      "https://customer-assets.emergentagent.com/job_gemini-alpine/artifacts/xjj2xjdt_IMMOCONCEPT_RIEME_VAL_BAGNES_EXT_NUIT_MAJ_HD.jpg",
      "https://customer-assets.emergentagent.com/job_gemini-alpine/artifacts/y0j095xe_IMMOCONCEPT_RIEME_VAL_BAGNES_SEJOUR_HD.jpg",
      "https://customer-assets.emergentagent.com/job_gemini-alpine/artifacts/2hloet6w_IMMOCONCEPT_RIEME_VAL_BAGNES_SEJOUR_CLOSUP_A.jpg",
      "https://customer-assets.emergentagent.com/job_gemini-alpine/artifacts/1p1amqsf_IMMOCONCEPT_RIEME_VAL_BAGNES_CHAMBRE_HD.jpg",
      "https://customer-assets.emergentagent.com/job_gemini-alpine/artifacts/fp8zu8z2_IMMOCONCEPT_RIEME_VAL_BAGNES_SEJOUR_CLOSUP_B.jpg",
      "https://customer-assets.emergentagent.com/job_gemini-alpine/artifacts/cu7rhqpv_IMMOCONCEPT_RIEME_VAL_BAGNES_SPA_HD.jpg"
    ],
    area: "~270 m²",
    type: "Chalet"
  };

  // Lodge des Combins
  const lodgesCombins = {
    id: 'combins',
    title: "Lodges des Combins",
    location: "Grimentz, Val d'Anniviers",
    description: "Résidence touristique premium. Investissement clé en main avec gestion locative professionnelle. Rendement cible 3-4%. Usage propriétaire 6 semaines/an.",
    images: [
      "https://customer-assets.emergentagent.com/job_7231506c-99db-422c-800b-87878e7e456c/artifacts/xstv99av_IMMOCONCEPT_RIEME_COMBINS_EXT_JOUR_HD.jpg",
      "https://customer-assets.emergentagent.com/job_7231506c-99db-422c-800b-87878e7e456c/artifacts/o3ivueef_IMMOCONCEPT_RIEME_COMBINS_EXT_NUIT_HD.jpg",
      "https://customer-assets.emergentagent.com/job_7231506c-99db-422c-800b-87878e7e456c/artifacts/hiumqzdg_IMMOCONCEPT_RIEME_COMBINS_TERRASSE_HD.jpg",
      "https://customer-assets.emergentagent.com/job_alpine-invest-3/artifacts/aevcux8v_ChatGPT%20Image%2017%20fe%CC%81vr.%202026%2C%2014_38_08.png",
      "https://customer-assets.emergentagent.com/job_alpine-invest-3/artifacts/w68lm10f_ChatGPT%20Image%2017%20fe%CC%81vr.%202026%2C%2014_19_55.png",
      "https://customer-assets.emergentagent.com/job_alpine-invest-3/artifacts/g0cvf83j_ChatGPT%20Image%2014%20fe%CC%81vr.%202026%2C%2009_39_17.png"
    ],
    area: "78-228 m²",
    type: "Investissement",
    rendement: "3-4%"
  };

  // Tufetsch Résidences
  const tufetsch = {
    id: 'tufetsch',
    title: "Tufetsch Résidences",
    location: "Tourtemagne, Valais",
    description: "12 appartements neufs de 2.5 pièces dans un cadre verdoyant. Terrasses spacieuses, PAC air-eau, panneaux photovoltaïques. Une nouvelle adresse résidentielle au coeur du Valais.",
    images: [
      "https://customer-assets.emergentagent.com/job_461c8c5b-3e0c-4d86-ba83-d0156d9ef57a/artifacts/zjauteen_Archsynth%20image%281%29%20copy%202.png",
      "https://customer-assets.emergentagent.com/job_tufetsch-residences/artifacts/50adsydw_archsynth_image%281%29.png",
      "https://customer-assets.emergentagent.com/job_750b5e79-a862-4cdd-b6c7-ee8f9da637e3/artifacts/dgr38nlm_Archsynth%20image%281%29%20copy%204.png",
      "https://customer-assets.emergentagent.com/job_750b5e79-a862-4cdd-b6c7-ee8f9da637e3/artifacts/zzxkbbop_Archsynth%20image%282%29%20copy%203.png",
      "https://customer-assets.emergentagent.com/job_tufetsch-residences/artifacts/qpvyvbm2_Archsynth%20image%286%29.png",
      "https://customer-assets.emergentagent.com/job_tufetsch-residences/artifacts/v96tpykp_Archsynth%20image%285%29.png"
    ],
    area: "60.5 - 63.5 m²",
    type: "Appartement",
    pieces: "2.5 pièces"
  };

  // La Badine - Antibes
  const labadine = {
    id: 'labadine',
    title: "Appartement La Badine",
    location: "Antibes, Côte d'Azur - France",
    description: "Trois pièces de 78,43 m² au premier étage avec ascenseur, ouvert sur 25 m² d'extérieur - une terrasse et un balcon. Résidence de 1,4 hectare avec piscine et courts de tennis rénovés. Parking et cave inclus. À 1,3 km de la plage.",
    images: [
      "/labadine/labadine-1-terrasse.jpg",
      "/labadine/labadine-2-piscine.jpg",
      "/labadine/labadine-3-sejour.jpg",
      "/labadine/labadine-4-tennis.jpg"
    ],
    area: "78,43 m²",
    pieces: "3 pièces",
    outdoor: "Terrasse + balcon",
    price: "480 000 €"
  };

  // Gestionnaires pour Chalet Gemini
  const handlePrevGemini = (e) => {
    e.stopPropagation();
    setCurrentImageGemini(prev => 
      prev === 0 ? chaletGemini.images.length - 1 : prev - 1
    );
  };

  const handleNextGemini = (e) => {
    e.stopPropagation();
    setCurrentImageGemini(prev => 
      prev === chaletGemini.images.length - 1 ? 0 : prev + 1
    );
  };

  // Gestionnaires pour Lodge des Combins
  const handlePrevCombins = (e) => {
    e.stopPropagation();
    setCurrentImageCombins(prev => 
      prev === 0 ? lodgesCombins.images.length - 1 : prev - 1
    );
  };

  const handleNextCombins = (e) => {
    e.stopPropagation();
    setCurrentImageCombins(prev => 
      prev === lodgesCombins.images.length - 1 ? 0 : prev + 1
    );
  };

  // Gestionnaires pour Tufetsch
  const handlePrevTufetsch = (e) => {
    e.stopPropagation();
    setCurrentImageTufetsch(prev => 
      prev === 0 ? tufetsch.images.length - 1 : prev - 1
    );
  };

  const handleNextTufetsch = (e) => {
    e.stopPropagation();
    setCurrentImageTufetsch(prev => 
      prev === tufetsch.images.length - 1 ? 0 : prev + 1
    );
  };

  // Gestionnaires pour La Badine
  const handlePrevLabadine = (e) => {
    e.stopPropagation();
    setCurrentImageLabadine(prev => 
      prev === 0 ? labadine.images.length - 1 : prev - 1
    );
  };

  const handleNextLabadine = (e) => {
    e.stopPropagation();
    setCurrentImageLabadine(prev => 
      prev === labadine.images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section id="properties" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e5a7a] mb-4">
            Biens à Vendre
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
            Nous vous invitons à découvrir une collection unique de résidences et chalets d'exception que nous concevons et développons dans les plus beaux lieux de Suisse.
          </p>
        </div>

        {/* Chalet Gemini - Projet 1 */}
        <Card
          onClick={() => navigate('/bien/chalet-gemini')}
          className="group overflow-hidden border-0 shadow-2xl hover:shadow-3xl transition-all duration-500 cursor-pointer bg-white mb-12"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Carrousel d'images */}
            <div className="relative h-96 lg:h-auto overflow-hidden">
              <img
                src={chaletGemini.images[currentImageGemini]}
                alt={chaletGemini.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              
              {/* Contrôles du carrousel */}
              <button
                onClick={handlePrevGemini}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
              >
                <ChevronLeft size={24} className="text-[#1e5a7a]" />
              </button>
              <button
                onClick={handleNextGemini}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
              >
                <ChevronRight size={24} className="text-[#1e5a7a]" />
              </button>

              {/* Indicateurs */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                {chaletGemini.images.map((_, index) => (
                  <div
                    key={index}
                    className={`h-2 rounded-full transition-all ${
                      index === currentImageGemini
                        ? 'w-8 bg-[#f5b800]'
                        : 'w-2 bg-white/60'
                    }`}
                  />
                ))}
              </div>

              <div className="absolute top-4 left-4">
                <span className="bg-[#f5b800] text-black px-4 py-2 rounded-full text-sm font-bold">
                  ⭐ PROJET PHARE
                </span>
              </div>
            </div>

            {/* Contenu */}
            <CardContent className="p-8 lg:p-12 flex flex-col justify-center">
              <h3 className="text-3xl md:text-4xl font-bold text-[#1e5a7a] mb-4 group-hover:text-[#f5b800] transition-colors">
                {chaletGemini.title}
              </h3>
              <div className="flex items-center text-gray-600 mb-4">
                <MapPin size={20} className="mr-2" />
                <span className="text-lg">{chaletGemini.location}</span>
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                {chaletGemini.description}
              </p>
              <div className="flex flex-wrap items-center gap-6 mb-6">
                <div className="flex items-center text-gray-600">
                  <Home size={18} className="mr-2 text-[#f5b800]" />
                  <span className="font-medium">{chaletGemini.area}</span>
                </div>
                <span className="bg-[#1e5a7a] text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {chaletGemini.type}
                </span>
              </div>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('/bien/chalet-gemini');
                }}
                className="bg-[#1e5a7a] hover:bg-[#f5b800] hover:text-black text-white font-semibold transition-all duration-300 w-full lg:w-auto"
              >
                Découvrir le chalet
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </CardContent>
          </div>
        </Card>

        {/* Lodge des Combins - Projet 2 */}
        <Card
          onClick={() => navigate('/bien/lodges-combins')}
          className="group overflow-hidden border-0 shadow-2xl hover:shadow-3xl transition-all duration-500 cursor-pointer bg-white mb-12"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Carrousel d'images */}
            <div className="relative h-96 lg:h-auto overflow-hidden">
              <img
                src={lodgesCombins.images[currentImageCombins]}
                alt={lodgesCombins.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              
              {/* Contrôles du carrousel */}
              <button
                onClick={handlePrevCombins}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
              >
                <ChevronLeft size={24} className="text-[#1e5a7a]" />
              </button>
              <button
                onClick={handleNextCombins}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
              >
                <ChevronRight size={24} className="text-[#1e5a7a]" />
              </button>

              {/* Indicateurs */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                {lodgesCombins.images.map((_, index) => (
                  <div
                    key={index}
                    className={`h-2 rounded-full transition-all ${
                      index === currentImageCombins
                        ? 'w-8 bg-[#f5b800]'
                        : 'w-2 bg-white/60'
                    }`}
                  />
                ))}
              </div>

              <div className="absolute top-4 left-4">
                <span className="bg-[#1e5a7a] text-white px-4 py-2 rounded-full text-sm font-bold">
                  💎 INVESTISSEMENT
                </span>
              </div>
            </div>

            {/* Contenu */}
            <CardContent className="p-8 lg:p-12 flex flex-col justify-center">
              <h3 className="text-3xl md:text-4xl font-bold text-[#1e5a7a] mb-4 group-hover:text-[#f5b800] transition-colors">
                {lodgesCombins.title}
              </h3>
              <div className="flex items-center text-gray-600 mb-4">
                <MapPin size={20} className="mr-2" />
                <span className="text-lg">{lodgesCombins.location}</span>
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                {lodgesCombins.description}
              </p>
              <div className="flex flex-wrap items-center gap-6 mb-6">
                <div className="flex items-center text-gray-600">
                  <Home size={18} className="mr-2 text-[#f5b800]" />
                  <span className="font-medium">{lodgesCombins.area}</span>
                </div>
                <div className="flex items-center text-gray-600">
                  <TrendingUp size={18} className="mr-2 text-[#f5b800]" />
                  <span className="font-medium">Rendement {lodgesCombins.rendement}</span>
                </div>
                <span className="bg-[#1e5a7a] text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {lodgesCombins.type}
                </span>
              </div>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('/bien/lodges-combins');
                }}
                className="bg-[#1e5a7a] hover:bg-[#f5b800] hover:text-black text-white font-semibold transition-all duration-300 w-full lg:w-auto"
              >
                Découvrir le projet
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </CardContent>
          </div>
        </Card>

        {/* Tufetsch Résidences - Projet 3 */}
        <Card
          onClick={() => navigate('/bien/tufetsch')}
          className="group overflow-hidden border-0 shadow-2xl hover:shadow-3xl transition-all duration-500 cursor-pointer bg-white"
          data-testid="tufetsch-card"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Carrousel d'images */}
            <div className="relative h-96 lg:h-auto overflow-hidden">
              <img
                src={tufetsch.images[currentImageTufetsch]}
                alt={tufetsch.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              
              {/* Contrôles du carrousel */}
              <button
                onClick={handlePrevTufetsch}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
              >
                <ChevronLeft size={24} className="text-[#1e5a7a]" />
              </button>
              <button
                onClick={handleNextTufetsch}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
              >
                <ChevronRight size={24} className="text-[#1e5a7a]" />
              </button>

              {/* Indicateurs */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                {tufetsch.images.map((_, index) => (
                  <div
                    key={index}
                    className={`h-2 rounded-full transition-all ${
                      index === currentImageTufetsch
                        ? 'w-8 bg-[#f5b800]'
                        : 'w-2 bg-white/60'
                    }`}
                  />
                ))}
              </div>

              <div className="absolute top-4 left-4">
                <span className="bg-green-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  🏠 NOUVEAU
                </span>
              </div>
            </div>

            {/* Contenu */}
            <CardContent className="p-8 lg:p-12 flex flex-col justify-center">
              <h3 className="text-3xl md:text-4xl font-bold text-[#1e5a7a] mb-4 group-hover:text-[#f5b800] transition-colors">
                {tufetsch.title}
              </h3>
              <div className="flex items-center text-gray-600 mb-4">
                <MapPin size={20} className="mr-2" />
                <span className="text-lg">{tufetsch.location}</span>
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                {tufetsch.description}
              </p>
              <div className="flex flex-wrap items-center gap-6 mb-6">
                <div className="flex items-center text-gray-600">
                  <Home size={18} className="mr-2 text-[#f5b800]" />
                  <span className="font-medium">{tufetsch.area}</span>
                </div>
                <span className="bg-[#1e5a7a] text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {tufetsch.pieces}
                </span>
                <span className="bg-[#1e5a7a] text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {tufetsch.type}
                </span>
              </div>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('/bien/tufetsch');
                }}
                className="bg-[#1e5a7a] hover:bg-[#f5b800] hover:text-black text-white font-semibold transition-all duration-300 w-full lg:w-auto"
                data-testid="tufetsch-button"
              >
                Découvrir le projet
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </CardContent>
          </div>
        </Card>
      </div>

      {/* Section Biens à l'étranger */}
      <div id="properties-abroad" className="max-w-7xl mx-auto px-6 lg:px-8 mt-24">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e5a7a] mb-4">
            Biens à l'étranger
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
            Découvrez nos opportunités immobilières sélectionnées sur la Côte d'Azur.
          </p>
        </div>

        {/* La Badine - Antibes */}
        <Card
          className="group overflow-hidden border-0 shadow-2xl hover:shadow-3xl transition-all duration-500 bg-white"
          data-testid="labadine-card"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Carrousel d'images */}
            <div className="relative h-96 lg:h-auto overflow-hidden">
              <img
                src={labadine.images[currentImageLabadine]}
                alt={labadine.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              
              {/* Contrôles du carrousel */}
              <button
                onClick={handlePrevLabadine}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
                data-testid="labadine-prev"
              >
                <ChevronLeft size={24} className="text-[#1e5a7a]" />
              </button>
              <button
                onClick={handleNextLabadine}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
                data-testid="labadine-next"
              >
                <ChevronRight size={24} className="text-[#1e5a7a]" />
              </button>

              {/* Indicateurs */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                {labadine.images.map((_, index) => (
                  <div
                    key={index}
                    className={`h-2 rounded-full transition-all ${
                      index === currentImageLabadine
                        ? 'w-8 bg-[#f5b800]'
                        : 'w-2 bg-white/60'
                    }`}
                  />
                ))}
              </div>

              <div className="absolute top-4 left-4">
                <span className="bg-green-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  NOUVEAU
                </span>
              </div>
            </div>

            {/* Contenu */}
            <CardContent className="p-8 lg:p-12 flex flex-col justify-center">
              <h3 className="text-3xl md:text-4xl font-bold text-[#1e5a7a] mb-4 group-hover:text-[#f5b800] transition-colors">
                {labadine.title}
              </h3>
              <div className="flex items-center text-gray-600 mb-4">
                <MapPin size={20} className="mr-2" />
                <span className="text-lg">{labadine.location}</span>
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                {labadine.description}
              </p>
              <div className="flex flex-wrap items-center gap-4 mb-6">
                <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                  {labadine.area}
                </span>
                <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                  {labadine.pieces}
                </span>
                <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                  {labadine.outdoor}
                </span>
                <span className="bg-[#f5b800] text-black px-3 py-1 rounded-full text-sm font-bold">
                  {labadine.price}
                </span>
              </div>
              <a
                href="/labadine/"
                className="inline-flex items-center justify-center bg-[#1e5a7a] hover:bg-[#f5b800] hover:text-black text-white font-semibold transition-all duration-300 w-full lg:w-auto px-6 py-3 rounded-md"
                data-testid="labadine-button"
              >
                Découvrir le bien
                <ArrowRight className="ml-2" size={20} />
              </a>
            </CardContent>
          </div>
        </Card>
      </div>
    </section>
  );
};